export default "<div class=\"message-container\">\n  <app-message *ngFor=\"let msg of lista\" [message]=\"msg\"></app-message>\n</div>\n";